import { useState, useEffect, useRef, useCallback } from "react";

const useTimer = (initialTime) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [timerActive, setTimerActive] = useState(false);
  const timerRef = useRef(null);
  const initialTimeRef = useRef(initialTime);
  const timeLeftRef = useRef(timeLeft);

  useEffect(() => {
    timeLeftRef.current = timeLeft;
  }, [timeLeft]);

  useEffect(() => {
    if (timerActive && timeLeftRef.current > 0) {
      if (timerRef.current) clearInterval(timerRef.current);

      timerRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 0) {
            clearInterval(timerRef.current);
            setTimerActive(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [timerActive]);

  const startTimer = useCallback(() => setTimerActive(true), []);
  const pauseTimer = useCallback(() => setTimerActive(false), []);
  const stopTimer = useCallback(() => {
    setTimerActive(false);
    if (timerRef.current) clearInterval(timerRef.current);
  }, []);

  const resetTimer = useCallback((newTime) => {
    setTimeLeft(newTime || initialTimeRef.current);
    setTimerActive(false);
    if (timerRef.current) clearInterval(timerRef.current);
  }, []);

  const formatTime = useCallback((seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  }, []);

  return {
    timeLeft,
    timerActive,
    startTimer,
    pauseTimer,
    resetTimer,
    stopTimer,
    formatTime,
  };
};

export default useTimer;
